/**
 * Ruta del registro al que apunta un aviso por correo, o null si no hay una
 * ruta segura para armarla (el aviso se muestra sin enlace).
 *
 * Solo usa rutas que existen en App.tsx:
 * - oferta          -> /oferta/:offerId (vista de la oferta, App.tsx:711)
 * - cuenta_cobranza -> /admin/cuentas-cobranza/:id/detalle (App.tsx:1179)
 * - contrato        -> /admin/legal/contratos (App.tsx:1194, no hay detalle por id)
 * - usuario         -> /admin/portal-tickets/todos?tab=mios (App.tsx:1401)
 * - ticket_chat_mensaje -> /admin/portal-tickets/todos[?ticket=folio] (App.tsx:1401)
 * - prospecto       -> null: el detalle vive en /admin/agent/*, portal sin servicio.
 */
export interface AvisoEnlazable {
  entidad_tipo: string | null;
  entidad_id: string | null;
  payload?: Record<string, unknown> | null;
}

const ID_SEGURO = /^[A-Za-z0-9_-]{1,64}$/;
const ENTERO = /^\d{1,12}$/;

export function enlaceAviso(aviso: AvisoEnlazable): string | null {
  const tipo = aviso.entidad_tipo;
  const id = aviso.entidad_id == null ? '' : String(aviso.entidad_id).trim();

  switch (tipo) {
    case 'oferta':
      return ID_SEGURO.test(id) ? `/oferta/${encodeURIComponent(id)}` : null;
    case 'cuenta_cobranza':
      return ENTERO.test(id) ? `/admin/cuentas-cobranza/${id}/detalle` : null;
    case 'contrato':
      return '/admin/legal/contratos';
    case 'usuario':
      return '/admin/portal-tickets/todos?tab=mios';
    case 'ticket_chat_mensaje': {
      const p = aviso.payload ?? {};
      const folio = String(p.ticket_numero ?? p.numero_ticket ?? p.numero ?? '');
      return ENTERO.test(folio)
        ? `/admin/portal-tickets/todos?ticket=${folio}`
        : '/admin/portal-tickets/todos';
    }
    default:
      return null;
  }
}
